import { Slot } from "radix-ui";
import { ComponentProps, useContext } from "react";
import { DrawerSelectContext } from "../drawer-select.context";

export type DrawerSelectTriggerProps = ComponentProps<"div"> & {
  asChild?: boolean;
};

export function DrawerSelectTrigger({
  asChild,
  ...props
}: DrawerSelectTriggerProps) {
  const ctx = useContext(DrawerSelectContext);
  const Comp = asChild ? Slot.Root : "div";

  const handleClick = () => {
    ctx.setIsOpen((prev) => !prev);
  };

  return <Comp {...props} onClick={handleClick} />;
}
